import React from "react";
import { formatPhone } from "../../../util/credit";
import { ICreditorInfo } from "../../../store/credit/types";
import { useTranslation } from "react-i18next";
interface IProps {
    data?: ICreditorInfo[];
}
const CreditHistoryCreditorContactInfoSingle: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    return (
        <React.Fragment>
            {props.data != null && props.data.length > 0 ? (
                <React.Fragment>
                    <h4 className=" margin-vertical-s">{props.data[0].bureau}</h4>
                    <div className="table-container scroll">
                        <table className="m-table-generic">
                            <caption className="sr-only">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.creditorContanctInfoSection.titleInfo")} {props.data[0].name}</caption>
                            <thead>
                                <tr>
                                    <th scope="col">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.creditorContanctInfoSection.name")}</th>
                                    <th scope="col">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.creditorContanctInfoSection.address")}</th>
                                    <th scope="col">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.creditorContanctInfoSection.phoneNumber")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.data.map((creditor) => (
                                    <tr key={"CreditorContact_ " + creditor.index}>
                                        <td>{creditor.name}</td>
                                        <td>{creditor.address}</td>
                                        <td>{!creditor.telephone ? "" : formatPhone(creditor.telephone)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </React.Fragment>
            ) : (
                ""
            )}
        </React.Fragment>
    );
};

export default CreditHistoryCreditorContactInfoSingle;
